<template>
    <!-- 组件主盒子 -->
    <div class="stbox">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>当前报警</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 搜索筛选 -->
        <el-form :inline="true" class="user-search">
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-refresh" @click="resetAlarm(1)">报警复位</el-button>
            </el-form-item>
        </el-form>

        <el-table size="small" ref="alarmTable" :data="listData" highlight-current-row
                  v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="60"></el-table-column>
            <el-table-column prop="dname" label="设备名" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="所属分组" show-overflow-tooltip></el-table-column>
            <el-table-column prop="alarm_status" label="故障类型" show-overflow-tooltip></el-table-column>
            <el-table-column prop="alarm_time" label="报警时间" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" label="操作" width="100">
                <template slot-scope="scope">
                    <el-button size="mini" @click="resetAlarm(scope.row)">复位</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script type="text/ecmascript-6">
    import {current, reset} from "../../api/userMG";

    export default {
        name: "welcome",
        data() {
            return {
                listData: [], //用户数据
                loading: false,
                selectedId: [],
            }
        },
        // 导入组件
        components: {},
        // 创建完毕状态(里面是操作)
        created() {
        },
        // 挂载结束状态(里面是操作)
        mounted() {
            this.getdata()
        },
        // 分页插件事件
        callFather(parm) {
            this.getdata()
        },
        // 里面的函数只有调用才会执行
        methods: {
            getdata(parameter) {
                this.loading = true
                current(parameter).then(res => {
                    if (res.code == 200) {
                        this.listData = res.result
                        this.loading = false
                    }
                })
            },
            resetAlarm(row) {
                if (row == 1) {
                    let selectedRows = this.$refs.alarmTable.selection
                    if (selectedRows.length == 0) {
                        this.$message.error('请先选择设备！')
                        return false;
                    }
                    let imei = []
                    selectedRows.forEach(item => {
                        imei.push(item.imei)
                    })
                    reset({imeis: imei}).then(res => {
                        if (res.code == 200) {
                            this.$message.success('指令发送完成！')
                            this.getdata()
                        }
                    });
                } else {
                    reset({imei: row.imei})
                        .then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '指令发送完成！'
                                })
                                this.getdata()
                            }
                        })
                        .catch(err => {
                            this.loading = false
                            this.$message.error('指令发送失败,请稍后再试！')
                        })
                }
            },
        }
    };
</script>
<style>
    .user-search {
        margin-top: 30px;
    }

    .stbox {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }

    .stbgc {
        background-color: #fff;
        height: 60px;
        line-height: 60px;
        border-radius: 5px;
        padding: 0px 16px;
    }

    .stsearch {
        text-align: center;
    }

    .text-c {
        text-align: center;
    }

    .delete {
        color: #0052D9;
    }

    .greenbg {
        background: rgba(13, 172, 120, 0.15);
        font-size: 12px;
        padding: 4px 8px;
        font-weight: 400;
        line-height: 22px;
        color: #0DAC78;
    }
</style>


// WEBPACK FOOTER //
// src/views/alarm/current.vue